


<div
  class="icon flex align-items-center justify-content-center border-circle p-2"
  [class.filled]="style === WarningIconStyle.FILLED"
  [class.outlined]="style === WarningIconStyle.OUTLINED"
  [attr.data-type]="type">

  <span class="pi pi-exclamation-triangle text-lg"></span>

</div>
